import { ReducerFnInterface } from '@context/type';
import {
  ProposalItemStateInterface,
  ProposalsStateInterface,
} from './proposals.type';

export const proposalsReducer: ReducerFnInterface<ProposalsStateInterface> = (
  state,
  { type, payload },
) => {
  switch (type) {
    case 'proposals_update_current_page':
      return {
        ...state,
        pending: {
          ...state.pending,
          currentPage: payload.currentPage,
        },
      };
    case 'proposals_loading':
      return {
        ...state,
        pending: {
          ...state.pending,
          isFetching: true,
          isFetched: false,
          error: false,
        },
      };
    case 'proposals_loading_success':
      return {
        ...state,
        pending: {
          ...state.pending,
          isFetching: false,
          isFetched: true,
          data: payload.data,
          meta: {
            ...payload.meta,
          },
          error: false,
        },
      };
    case 'proposals_loading_error':
      return {
        ...state,
        pending: {
          ...state.pending,
          isFetching: false,
          isFetched: true,
          data: [],
          meta: {
            next: null,
            page: 1,
            previous: null,
            total: 0,
          },
          error: true,
        },
        errorStatus: payload.statusCode,
      };
    case 'proposal_selection_set':
      return {
        ...state,
        selection: payload,
      };
    case 'proposal_selection_clear':
      return {
        ...state,
        selection: null,
      };
    case 'proposal_last_location_loading': {
      const newProposal = state.pending.data.map((proposal) => {
        const tempProposal = { ...proposal };

        if (tempProposal.id === payload.proposalId) {
          tempProposal.lastLocationState = {
            fetch: {
              isFetching: payload.isFetching,
            },
            error: false,
          };
        }

        return tempProposal;
      });

      return {
        ...state,
        pending: {
          ...state.pending,
          data: newProposal,
        },
      };
    }

    case 'proposal_last_location_loaded': {
      let tempSelection = null || ({} as ProposalItemStateInterface);
      const newProposal = state.pending.data.map((proposal) => {
        const tempProposal = { ...proposal };
        if (tempProposal.id === payload.proposalId) {
          tempProposal.trucker.phone = payload.proposal.trucker.phone;
          if (payload.proposal.trucker.lastLocation) {
            tempProposal.trucker.lastLocation =
              payload.proposal.trucker.lastLocation;
          }
          tempProposal.lastLocationState = {
            fetch: {
              isFetching: false,
            },
            error: false,
          };
          tempSelection = { ...payload.proposal };
          tempSelection.lastLocationState = {
            fetch: {
              isFetching: false,
            },
            error: false,
          };
        }

        return tempProposal;
      });

      return {
        ...state,
        pending: {
          ...state.pending,
          data: newProposal,
        },
        selection: tempSelection,
      };
    }

    case 'proposal_last_location_error': {
      const newProposal = state.pending.data.map((proposal) => {
        const tempProposal = { ...proposal };

        if (tempProposal.id === payload.proposalId) {
          tempProposal.lastLocationState = {
            fetch: {
              isFetching: false,
            },
            error: payload.error,
          };
        }

        return tempProposal;
      });
      return {
        ...state,
        pending: {
          ...state.pending,
          data: newProposal,
        },
      };
    }

    default:
      return state;
  }
};

proposalsReducer.key = 'proposals';
proposalsReducer.initialState = {
  pending: {
    isFetching: true,
    isFetched: false,
    currentPage: 1,
    data: [],
    meta: {
      next: null,
      page: 1,
      previous: null,
      total: 0,
    },
    error: false,
  },
  selection: null,
};
